import Menu, { MenuDTO } from '../Menu';

export const convertFromMenuDTO = (dto: MenuDTO): Menu => dto;
